export default {"src":"/_next/static/media/generic-thumbnail-assessment.4b1458f7.svg","height":74,"width":60,"blurWidth":0,"blurHeight":0};